import { Envelope, PencilSimpleLine } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { FLOW_TYPE_OPTIONS } from "../../../../constants";
import { getFlowTitle } from "../../../../utils";

import type { CampaignFlow } from "../../../../types";

interface FlowsPreviewProps {
  flows: CampaignFlow[];
}

export default function FlowsPreview({ flows }: FlowsPreviewProps) {
  const isDesktop = useTwBreakpoint("lg");

  const flowsTagsComponent = (
    <div className="flex flex-wrap gap-1.5 max-lg:mt-3">
      {flows.map((flow) => {
        const { tagVariant } = FLOW_TYPE_OPTIONS[flow.type];

        return (
          <Tag
            key={flow.id}
            variant={tagVariant}
            leftIcon={flow.type === "INMAIL_OPTIMIZATION" && <Envelope />}
          >
            {getFlowTitle(flow)}
          </Tag>
        );
      })}
    </div>
  );

  const detailsContent = (
    <>
      <div className="flex flex-1 flex-col gap-y-0.5">
        <h3 className="text-button-md">
          Campaign Flow{flows.length > 1 ? "s" : ""}
        </h3>
        <p className="text-xs text-black-500">
          How the campaign will engage with your targets
        </p>
      </div>

      <RenderIf condition={isDesktop}>{flowsTagsComponent}</RenderIf>

      <div className="ml-2.5 h-10 w-px bg-black-200 max-lg:hidden" />

      <Button
        intent="iconOnly"
        variant="secondary-black"
        className="ml-2.5"
        asChild
      >
        <Link to="../flows">
          <PencilSimpleLine />
        </Link>
      </Button>
    </>
  );

  return (
    <section className="flex flex-col rounded-3xl border border-black-200 p-3 lg:flex-row lg:items-center">
      {isDesktop ? (
        detailsContent
      ) : (
        <div className="flex">{detailsContent}</div>
      )}

      <RenderIf condition={!isDesktop}>{flowsTagsComponent}</RenderIf>
    </section>
  );
}
